import { Card } from '@axo/ui-core/components/Card';
import { useWatch } from 'react-hook-form';
import { DebtDetailsHeader } from './DebtDetailsHeader';
import { EditableDebtDetails } from './EditableDebtDetails';
import { IdleDebtDetails } from './IdleDebtDetails';

export type DebtProps = {
  index: number;
  debtNumber: number;
  onEdit: () => void;
  onRemove: () => void;
  editingDebtIndex?: number;
};
export const DebtDetails = (props: DebtProps) => {
  const { index, editingDebtIndex } = props;

  const isEditing = editingDebtIndex === index;

  const type = useWatch({ name: `LoanApplication/Debts.${index}.Type` });

  const source = useWatch({ name: `LoanApplication/Debts.${index}.Source` });

  return (
    <Card spacing="small" data-testid={`debt-card-${index}`}>
      <DebtDetailsHeader {...props} type={type} source={source} />

      {!isEditing && <IdleDebtDetails index={index} />}

      {isEditing && <EditableDebtDetails {...props} />}
    </Card>
  );
};
